import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

import "../../css/header.css";
import logo from '../../images/logo.svg';

const Header = (props) => {
    const [resources, setResources] = useState({});
    const { language } = useParams();

    useEffect(() => {
        requestResources();
    }, [language]);

    const requestResources = async () => {
        try {
            const res = await axios.get(`form/resources/${language}`);
            setResources(res.data?.translation);
        } catch (error) {
            console.error(error?.response?.data);
        }
    };

    return (
        <>
            <header className="madame-header">

                <nav className="madame-nav" style={{paddingTop: "17px"}}>
                    <ul className="nav-menu madame">
                        <li className="nav-item madame">
                            <a href="https://www.madamebissegger.ch/" className="nav-link madame">
                                START
                            </a>
                        </li>
                        <li className="nav-item madame">
                            <a href="https://www.madamebissegger.ch/tickets" className="nav-link madame">
                                TICKETS
                            </a>
                        </li>
                        <li className="nav-item madame">
                            <a href="https://www.madamebissegger.ch/beiz" className="nav-link madame">
                                RESTAURANT
                            </a>
                        </li>
                        <li className="nav-item madame has-dropdown">
                            <span className="nav-link madame cursor-pointer">
                                ÜBER UNS
                            </span>
                            <ul className="dropdown-menu madame">
                                <li>
                                    <a href="https://www.madamebissegger.ch/kopie-von-%C3%BCber-uns" className="dropdown-link madame">
                                        TEAM
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.madamebissegger.ch/geschichte" className="dropdown-link madame">
                                        GESCHICHTE
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li className="nav-item madame has-dropdown">
                            <span className="nav-link madame cursor-pointer">
                                GRUPPEN
                            </span>
                            <ul className="dropdown-menu madame margin-left-50">
                                <li>
                                    <a href="https://www.madamebissegger.ch/ihr-event-bei-bisseggers" className="dropdown-link madame">
                                        BEI UNS
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.madamebissegger.ch/events" className="dropdown-link madame">
                                        BEI IHNEN
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li className="nav-item madame">
                            <a href="https://www.madamebissegger.ch/kurse" className="nav-link madame">
                                KURSE
                            </a>
                        </li>
                        <li className="nav-item madame">
                            <a href="https://www.madamebissegger.ch/kontakt" className="nav-link madame">
                                INFOS
                            </a>
                        </li>
                    </ul>
                </nav>

                <div className="text-center">
                    <a href="https://www.madamebissegger.ch/">
                        <img className="logo" src={logo} alt="Madame Bissegger logo" />
                    </a>
                </div>
            </header>
        </>
    );
};

export default Header;
